import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UserContextProvider } from './contexts/userContext';
import ErrorPage from './pages/error/error';
import { ProjectContextProvider } from './contexts/projectContext';
import MembersPage from './pages/members/members';
import HomePage from './pages/home/home';
import PrivacyPage from './pages/privacy-policy/privacy-policy';
import TermsPage from './pages/terms-of-service/terms-of-service';
import { ArticleContentPage } from './pages/article-content/article-content';

import { ArticleContextProvider } from './contexts/articleContext';
import { CommentContextProvider } from './contexts/commentContext';
import VisitProfilePage from './pages/visit-profile/visit-profile';
import { ChannelPage } from './pages/channel/channel';
import LoginPage from './pages/login/login';
import { CommonContextProvider } from 'contexts/commonContext';
import { ToastContainer } from 'react-toastify';
import App from 'pages/app/app';
import ExplorePage from './pages/explore/explore';
import ChannelArticlesPage from './pages/channel/channel-articles';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/c/:channelPath',
        element: <ChannelPage />,
      },
      {
        path: '/c/:channelPath/:article_id',
        element: <ArticleContentPage />,
      },
      {
        path: '/members',
        element: <MembersPage />,
      },
      {
        path: '/home',
        element: <HomePage />,
      },
      {
        path: '/a/:article_id',
        element: <ArticleContentPage />,
      },
      { path: '/u/:userId', element: <VisitProfilePage /> },
      {
        path: '/documentation',
        element: <ExplorePage />,
      },
      {
        path: '/c/:channelPath/articles',
        element: <ChannelArticlesPage />,
      },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <CommonContextProvider>
    <ProjectContextProvider>
      <ArticleContextProvider>
        <CommentContextProvider>
          <UserContextProvider>
            <ToastContainer />
            <RouterProvider router={router} />
          </UserContextProvider>
        </CommentContextProvider>
      </ArticleContextProvider>
    </ProjectContextProvider>
  </CommonContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
